export default "__VITE_ASSET__yxjoJqWY__"